var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import React from 'react';
import DocumentSection from '../../../components/Documento/DocumentSection';
import { useWizard } from '../../../components/Wizard/useWizard';
import { WizardButtons } from '../../../components/Wizard/WizardButtons';
import { useDocumentValidation } from '../../../hooks/useDocumentValidation';
import { useProcessContext } from '../context/ProcessContext';
var DocumentoEmpresaForm = function (_a) {
    var _b, _c, _d, _e;
    var _f = _a.disabled, disabled = _f === void 0 ? false : _f;
    var _g = useWizard(), prevStep = _g.prevStep, nextStep = _g.nextStep;
    var _h = useProcessContext(), servico = _h.servico, processo = _h.processo, analise = _h.analise, updateDocumentosByEmpresa = _h.updateDocumentosByEmpresa, isLoading = _h.isLoading;
    var secoesDocumentos = (_c = (_b = servico === null || servico === void 0 ? void 0 : servico.secoesDocumentos) === null || _b === void 0 ? void 0 : _b.filter(function (x) { return x.categoria === 'EMPRESA'; })) !== null && _c !== void 0 ? _c : [];
    var _j = useDocumentValidation((_e = (_d = processo === null || processo === void 0 ? void 0 : processo.empresa) === null || _d === void 0 ? void 0 : _d.documentos) !== null && _e !== void 0 ? _e : []), documentosAnexados = _j.documentosAnexados, errors = _j.errors, validateAllSections = _j.validateAllSections, handleUpdateDocumento = _j.handleUpdateDocumento;
    var handleSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var allValid;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (disabled) {
                        nextStep();
                        return [2 /*return*/];
                    }
                    allValid = validateAllSections(secoesDocumentos);
                    if (!allValid) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, updateDocumentosByEmpresa(documentosAnexados)];
                case 1:
                    _a.sent();
                    nextStep();
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Box, { children: [_jsx(Typography, { variant: "h5", sx: { mb: 4 }, children: "Documentos da Empresa" }), secoesDocumentos.map(function (secao) { return (_jsx(Box, { sx: { mb: 4 }, children: _jsx(DocumentSection, { secao: secao, disabled: disabled, analise: analise, documentosAnexados: documentosAnexados, onUpdateDocumento: handleUpdateDocumento, errors: errors[secao.id] }) }, secao.id)); }), _jsx(WizardButtons, { nextClick: handleSubmit, prevClick: function () { return prevStep(); }, isSubmitting: isLoading })] }));
};
export default DocumentoEmpresaForm;
